module.exports = __webpack_public_path__ + "img/book_4.674b4d1b.jpg";